module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("payment_method_notice", [["div",{"class":"gui-notice-item &&0&&","notice-alias":""},[["span",{"data-item":"","data-item-alias":"","data-item-id":"","class":"notice-close"},[],[["_iteration","data-item",true],["alias","data-item-alias",true],["_id","data-item-id",true]]],["div",{"class":"message"},[["span",{"data-fox-alias":"1","data-fox-context":"payment_method_notice"},[["textNode",{"text":"Please select new Payout Method"}]]]]]],[["type","class"],["alias","notice-alias",true]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/templates/account/paymentMethodNotice.tpl
// module id = 225
// module chunks = 2